import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { MenuPlannerCreatedDtoSchema } from '../schemas/MenuPlannerCreatedDto';

export const PathParametersSchema = z.object({
	menuPlanId: z.string(),
});
export type PathParameters = z.infer<typeof PathParametersSchema>;

// No QueryParameters

export const RequestBodySchema = z.array(z.string());
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.array(z.lazy(() => MenuPlannerCreatedDtoSchema));
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	pathParameters: PathParameters;
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string =
		SERVICEBASEURL.BACKEND + `/MenuPlanner/Publish/${input.pathParameters.menuPlanId}/publish`;
	return (await axios.post(url, input.requestBody).toOptionalFiltered(validator)).map(
		(x) => x.data
	);
}
